import { Country } from '@rtls/core/models/location/country.model';
import { chance, nullable } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const countryFactory = Factory.makeFactory<Country>({
	id: Factory.each((i) => nullable(i)),
	code: Factory.each(() => nullable(chance.country())),
	name: Factory.each(() => nullable(chance.country({ full: true }))),
});
